import { AppName } from '../utils/Constants';
import { StringMap } from '../utils/TypeDefinitions';

export const storageConstants = {
	DOMAIN_COOKIE_TABLE: 'DomainCookieTable',
	PRIMARY_TOKEN_TABLE: 'PrimaryTokenTable',
	SECONDARY_TOKEN_TABLE: 'SecondaryTokenTable',
	OLD: 'Old',
	REFERENCE_URI: 'referenceUri',
	AUTH_DOMAIN: 'authDomain',
	SERVICE_URL: 'serviceURL',
	SERVICE_URL_REFERENCE_URI: 'serviceURL_referenceUri',
	AUTH_DOMAIN_REFERENCE_URI: 'authDomain_referenceUri',
	TOKEN_FOR_SERVICE: 'tokenForService',
	TOKEN_FOR_SERVICE_REFERENCE_URI: 'tokenForService_referenceUri',
	TOKEN: 'token',
	DOMAIN: 'domain',
	KEY: 'key',
	INDEX: 'index',
	OIDC_TOKENS_TABLE: 'OIDCTokens',
	OIDC_ENDPOINTS_TABLE: 'OIDCEndpoints',
	STORE_CONFIGURATION_TABLE: 'StoreConfigurations',
	CREDENTIALS_TABLE: 'Credentials',
	PREPOPULATED_CREDENTIALS_TABLE: 'PrepopulatedCredentials',
	AUTH_SERVICE_URL: 'authServiceUrl',
	INDEXEDDB: 'IndexedDB',
	INMEMORY: 'InMemory',
};
export const primaryTokenStatusConstants = {
	/* PRIMARY_TOKEN_STORED is used when a queued request can skip ahead to the secondary token flow 
    because a previous request for the same store already got and stored the primary token in indexeddb. */
	PRIMARY_TOKEN_STORED: 'PRIMARY_TOKEN_STORED',
	ERROR_PRIMARY_TOKEN_FETCH_FAILED: 'ERROR_PRIMARY_TOKEN_FETCH_FAILED',
	ERROR_CANCEL_LOGIN: 'ERROR_CANCEL_LOGIN',
	ERROR_AUTHDOMAIN_CHANGED: 'ERROR_AUTHDOMAIN_CHANGED',
	ERROR_SILENT_LOGIN_FAILURE: 'ERROR_SILENT_LOGIN_FAILURE',
};
export const stringConstants = {
	GET: 'GET',
	POST: 'POST',
	INVALID_PRIMARY_TOKEN_SERVICE_URL: 'INVALID_PRIMARY_TOKEN_SERVICE_URL',
	ERROR_MISSING_REFERENCE_URI: 'ERROR_MISSING_REFERENCE_URI',
	ERROR_OIDC_ENDPOINTS_FETCH_FAILURE: 'ERROR_OIDC_ENDPOINTS_FETCH_FAILURE',
	ERROR_OIDC_ENDPOINTS_UNAVAILABLE: 'ERROR_OIDC_ENDPOINTS_UNAVAILABLE',
	ERROR_OIDC_NOT_SUPPORTED: 'ERROR_OIDC_NOT_SUPPORTED',
	ERROR_OIDC_CLIENT_NOT_SUPPORTED: 'ERROR_OIDC_CLIENT_NOT_SUPPORTED',
	ERROR_MISSING_OIDC_CONFIGURATION: 'ERROR_MISSING_OIDC_CONFIGURATION',
	LONG_LIVED_TOKEN_SUPPORT_DISABLED: 'Long Lived Token Support Disabled on Client',
	AUTHWEBVIEW: 'authwebview',
	OIDCWEBVIEW: 'oidcwebview',
	OIDC_SCOPES: 'offline_access',
	OIDC_SCOPES_WITH_COMPRESSED_GROUPS: 'offline_access allow_compressed_groups openid',
	ERROR_HANDLING_AUTHDOMAIN_CHANGE: 'ERROR_HANDLING_AUTHDOMAIN_CHANGE',
	ERROR_HANDLING_OIDC_CLIENTID_CHANGE: 'ERROR_HANDLING_OIDC_CLIENTID_CHANGE',
	CLIENT_ID_NOT_PRESENT: 'CLIENT_ID_NOT_PRESENT',
	RESUME_PRIMARY_TOKEN_OR_AAAC_FETCH: 'RESUME_PRIMARY_TOKEN_OR_AAAC_FETCH',
	NSC_AAAC_COOKIE_FETCHED: 'NSC_AAAC_COOKIE_FETCHED',
	USER_CANCELLED_AUTH: 'USER_CANCELLED_AUTH',
	INVALID_GRANT: 'invalid_grant',
};

export const integerConstants = {
	TOKEN_RECEIVED: 1,
	TOKEN_NOT_RECEIVED: 0,
};
export const headerConstants = {
	AUTHENTICATE_HEADER: 'WWW-Authenticate',
	SET_COOKIE_HEADER: 'Set-Cookie',
	AUTH_DOMAIN_HEADER: 'X-Citrix-Athena-Auth-Domain',
	CACHE_CONTROL: 'Cache-Control',
	COOKIE_HEADER: 'Cookie',
	AUTHORIZATION_HEADER: 'Authorization',
	CITRIX_AUTH_SCHEME: 'CitrixAuth',
	AM_LABEL_TYPES:
		'confirmation,error,heading,heading2,hyperlink,image,information,none,plain,warning',
	AM_CREDENTIAL_TYPES: 'none,webview',
	AM_ONPREM_CREDENTIAL_TYPES:
		'domain,newpassword,none,passcode,password,pin,realm,rsa-next-passcode,rsa-next-tokencode,rsa-passcode,rsa-pin,savecredentials,textcredential,username,webview',
	AM_LABEL_TYPE_HEADER: 'X-Citrix-AM-LabelTypes',
	AM_CREDENTIAL_TYPE_HEADER: 'X-Citrix-AM-CredentialTypes',
	BEARER: 'Bearer',
	TRANSACTION_ID: 'Citrix-TransactionId',
	TOKEN_REQUEST_CONTENT_TYPE: 'application/vnd.citrix.requesttoken+xml',
	TOKEN_RESPONSE_CONTENT_TYPE: 'application/vnd.citrix.requesttokenresponse+xml',
	AUTH_RESPONSE_CONTENT_TYPE: 'application/vnd.citrix.authenticateresponse-1+xml',
	REQUEST_CONTENT_TYPE: 'application/x-www-form-urlencoded',
	GATEWAY_SESSION_CONTENT_TYPE: 'application/vnd.citrix.gatewaysession-1+xml',
	ACCEPT_LANGUAGE: 'Accept-Language',
	CONTENT_TYPE: 'Content-Type',
	CLOSE: 'Close',
};
export const statusConstants = {
	'100': 100,
	'101': 101,
	'102': 102,
	'103': 103,
	'200': 200,
	'201': 201,
	'202': 202,
	'203': 203,
	'204': 204,
	'205': 205,
	'206': 206,
	'207': 207,
	'208': 208,
	'226': 226,
	'300': 300,
	'301': 301,
	'302': 302,
	'303': 303,
	'304': 304,
	'305': 305,
	'306': 306,
	'307': 307,
	'308': 308,
	'400': 400,
	'401': 401,
	'404': 404,
};

export enum Platform {
	WINDOWS = 'windows',
	LINUX = 'linux',
	MAC = 'mac',
	IOS = 'iOS',
	ANDROID = 'android',
}

export const OIDCClients: Record<Platform, string> = {
	windows: 'windows-aml-app-athena-client',
	linux: 'linux-aml-app-athena-client',
	mac: 'mac-aml-app-athena-client',
	iOS: 'ios-apps-athena-client',
	android: 'android-apps-athena-client',
};

type RedirectURIs = Record<Platform, Partial<Record<AppName, string>>>;

const OIDCRedirectURIs: RedirectURIs = {
	windows: {
		workspace: 'ctxwinamloauth://oidc-longlivedtoken/login',
		citrixBrowser: 'ctxwinamloauth://oidc-longlivedtoken/login',
	},
	linux: {
		workspace: 'ctxlinuxamloauth://oidc-longlivedtoken/login',
		citrixBrowser: 'ctxlinuxamloauth://oidc-longlivedtoken/login',
	},
	mac: {
		workspace: 'ctxmacamloauth://oidc-longlivedtoken/login',
		citrixBrowser: 'ctxmacamloauth://oidc-longlivedtoken/login',
	},
	iOS: {
		citrixBrowser: 'ctxceboidc://oidc-longlivedtoken/login',
	},
	android: {
		citrixBrowser: 'ctxceboidc://oidc-longlivedtoken/login',
	},
};

export function getOIDCRedirectURI(
	platform: Platform,
	appName: AppName
): string | undefined {
	return OIDCRedirectURIs[platform]?.[appName];
}

export const basicHdrs: { [key: string]: string } = {
	'Cache-Control': 'no-cache',
	'X-Citrix-IsUsingHTTPS': 'Yes',
};

export const gatewayConstants: StringMap = {
	ROAMING_ACCOUNTS_PATH: '/Citrix/Roaming/Accounts',
	LOGON_URL_BASIC: '/cgi/login',
	CVPN_LOGOUT: '/cgi/logout',
	CHALLENGE_RESPONSE: '/cgi/dlge',
	WEB_INTERFACE_LOGOUT: '/logout.aspx',
	DISCOVER_PROBE_PATH: '/AGServices/discover',
	FORMS_PROBE_PATH: '/cgi/authenticate',
	INDEX_URL: '/vpn/index.html',
	AUTHENTICATE_RESPONSE: 'application/vnd.citrix.authenticateresponse-1+xml',
	GATEWAY_SESSION_RESPONSE: 'application/vnd.citrix.gatewaysession-1+xml',
	LABEL_TYPES:
		'confirmation,error,heading,heading2,hyperlink,image,information,none,plain,warning',
	CREDENTIAL_TYPES:
		'domain,newpassword,none,passcode,password,pin,realm,rsa-next-passcode,rsa-next-tokencode,rsa-passcode,rsa-pin,savecredentials,textcredential,username,webview',
	GATEWAY_TERMINAL_MIMETYPE: 'application/vnd.citrix.gatewaysession-1+xml',
	SSO_FAILURE_REASON_HEADER: 'X-Citrix-SSOFailure-Reason',
	SSO_FAILURE_BAD_CREDS: 'BadCredentials',
};
